module.exports = __webpack_public_path__ + "img/chevron-left-small.21e739a5.svg";